export default {
      id: "arrow-special-left-old-usage",
      viewBox: "0 0 32 32",
      url: __webpack_public_path__ + "sprite.svg#arrow-special-left-old",
      toString: function () {
        return this.url;
      }
    }


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/arrow-special-left-old.svg
// module id = 127
// module chunks = 241 242 243